import angular from 'angular';
import syncOrderModal from './sync-order-modal/sync-order-modal.view.html';
import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';

let inject = [
  '$scope',
  'OrdersService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  '$timeout',
  'Pagination',
  'SessionService',
  '$window'
];

class OrdersController {
  constructor($scope, OrdersService, $state, $rootScope, SharedService, $uibModal, $timeout, Pagination, SessionService, $window) {
    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.OrdersService = OrdersService;
    this.Pagination = Pagination;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
    this.$window = $window;
    this.searchText = '';
    this.sortType = 'orderId';
    this.sortReverse = true;
    this.userOrders = [];
    this.summary = [];
    this.itemsPerPage = 40;
    this.loadingUserOrders = true;
    this.loadedUserOrders = false;
    this.errorloadingUserOrders = false;
    this.currentPage = 1;
    this.actualPage = 0;
    this.filters = {};
    this.filtersCopy = {};


    this.maxSize = 5;
    this.bigTotalItems = 0;
    this.bigCurrentPage = 1;
    this.totalItemsPage = 12;
    this.statictics = {};
    this.userOrdersFiltered = {};

    this.count = 0;
    this.mostrar_estado_pedido = 0;
  }

  $onInit() {
    // this.shCtrl.currentUser = this.SessionService.get('currentUser');
    this.getUserOrders();
    this.getSummaryQuotes();
    this.getUserStatistics();

  }

  duplicateOrder(order) {
    this.loadingDuplicateOrders = true;
    let userId = '', sellerId = '';
    userId = this.shCtrl.globals.currentUser.userId;
    try {
      sellerId = this.shCtrl.globals.currentUser.sellerId;
    } catch (e) {
    }
    this.OrdersService.duplicateOrderById(userId, sellerId, order.orderId).then(response => {
      this.loadingDuplicateOrders = false;
      if (!response.error) {
        this.SessionService.put('cartId', response.cartId);
        this.$state.go('home.cart');
      } else {
        alert('No se pudo completar la acción.');
      }
    });
  }

  showSort(value) {
    this.sort = value;
  }

  getSummaryQuotes() {
    let globals = this.shCtrl.globals;

    let userId = '';
    try {
      userId = globals.currentUser.userId;
    } catch (e) {
    }

    let sellerId = '';
    try {
      sellerId = globals.currentUser.sellerId;
    } catch (e) {
    }
    this.loadingUserOrders = true;
    this.loadedUserOrders = false;
    this.errorloadingUserOrders = false;

    if (userId) {
      this.OrdersService.getSummaryQuotes({
        'userId': userId,
        'sellerId': sellerId,
        'typeOrders': ''
      }).then(response => {

      }).catch(reason => {

      });
    }
  }

  getUserOrders() {
    let globals = this.shCtrl.globals;

    let userId = '';
    try {
      userId = globals.currentUser.userId;
    } catch (e) {
    }

    let sellerId = '';
    try {
      sellerId = globals.currentUser.sellerId;
    } catch (e) {
    }

    let data = {
      'userId': userId,
      'sellerId': sellerId,
      'typeOrders': '',
      'range': this.filterRange,
      'limit': this.totalItemsPage,
      'page': this.bigCurrentPage,
      'filters': this.filters
    };

    this.filtersCopy = angular.copy(this.filters);
    this.loadingUserOrders = true;
    this.loadedUserOrders = false;
    this.errorloadingUserOrders = false;
    if (userId) {
      this.OrdersService.getUserOrders(data).then(response => {
        this.loadingUserOrders = false;
        this.loadedUserOrders = true;
        this.errorloadingUserOrders = false;

        this.pagination = this.Pagination.getNew(40);
        this.userOrders = response.orders;
        console.log(response);
        this.mostrar_estado_pedido = response.mostrar_estado_pedido;
        this.bigTotalItems = this.userOrders.totalItems;
      }).catch(reason => {
        this.loadingUserOrders = false;
        this.loadedUserOrders = true;
        this.errorloadingUserOrders = true;
      });
    }
  }

  payNow(orderId, order) {

    let userId = '';
    try {
      userId = globals.currentUser.userId;
    } catch (e) {
    }

    this.OrdersService.recalculateOrder(orderId, userId).then(response => {
      if (!response.error) {

        if (order.paymentStateName == "Procesando pago") {
          let options = {
            title: '',
            isHtml: true,
            content: "Lo sentimos! El pago de tu pedido está siendo procesado. Por favor intentalo de nuevo más tarde.",
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Cerrar'
          };
          this.messageResponse(options);
          return
        }

        this.$window.location = window.__env.envApiServiceBaseUri + '/order/pay-gate?id=' + orderId;

      } else {

        if (order && response.data) {
          order.paymentStateName = response.data;
        }

        let options = {
          title: response.title,
          isHtml: true,
          content: response.message,
          size: '',
          showBottonCancel: false,
          textActionCancel: '',
          textAction: 'Aceptar'
        };
        this.messageResponse(options);
      }
    });
    //this.$window.location = this.shCtrl.ngAuthSettings.config.env.apiEndPoint + '/order/pay-gate?id=' + orderId;
  }

  /**
   Set item per page on the pagination
   @method setPagination
   @param itemsPerPage {Integer} Items per page on the pager
   @example
   setpagination(8)
   */
  setPagination(itemsPerPage) {
    this.totalItemsPage = itemsPerPage;
    this.bigCurrentPage = 1;
    this.getUserOrders();
  };

  changePageOrdes(num) {
    this.actualPage = num - 1;
  }

  syncOrder(orderId, orderData) {
    let options = {
      orderId
    };
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: syncOrderModal,
      controller: 'SyncOrderModalController',
      controllerAs: 'mdCtrl',
      size: '',
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(result => {
      orderData.sincronizado = result;
    }).catch(reason => {

    });
  }

  updatePaginationPosition() {
    if (this.pagination.page <= (this.pagination.numPages - 3)) {
      $('.pagination-items ul').css('margin-left', (this.pagination.page * (-35)) + 'px');
    }
  }

  messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller: 'ModalResponseController',
      controllerAs: 'mdCtrl',
      size: options.size,
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(() => {
      if (callAcept) {
        callback();
      }
    }).catch(reason => {
      if (callCancel) {
        callbackCancel();
      }
    });
  }

  getFilters() {

    if (!angular.equals(this.filtersCopy, this.filters)) {
      this.getUserOrders();
    }

  }

  getUserStatistics() {
    let globals = this.shCtrl.globals;
    let userId = '';
    try {
      userId = globals.currentUser.userId;
    } catch (e) {
    }

    let sellerId = '';
    try {
      sellerId = globals.currentUser.sellerId;
    } catch (e) {
    }
    let data = {
      'userId': userId,
      'sellerId': sellerId,
      'typeOrders': '',
    }
    if (userId) {
      this.OrdersService.getUserOrdersStatistics(data).then(response => {


        // this.pagination = this.Pagination.getNew(40);
        this.statictics = response.orders;
        // this.bigTotalItems = this.userOrders.totalItems;
      }).catch(reason => {

      });
    }
  }

  rangeChange() {

    if ((angular.isDefined(this.filterRange.date1) && angular.isDefined(this.filterRange.date2)) && (this.filterRange.date1 != null && this.filterRange.date2 != null)) {


      if (this.filterRange.date1 > this.filterRange.date2) {
        alert("la fecha inicial no puede ser mayor a la fecha final");
      } else {
        this.getUserOrders();
      }
    }

  }

  clearFilter() {
    this.filterRange = {};
    this.getUserOrders();
  }
}

OrdersController.$inject = inject;

export default OrdersController;




/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/orders/orders.controller.js
 **/